import type { OwaDate } from 'owa-datetime';
import { addDatapointConfig } from 'owa-analytics-actions';
import { action } from 'satcheljs';

/**
 * action invoked when user clicks on surface blank space
 */
export const onSurfaceClick = action(
    'onSurfaceClick',
    (
        start: OwaDate,
        end: OwaDate,
        isAllDay: boolean,
        isClickAndDragEvent: boolean,
        selectedCalendarFolderId?: string
    ) =>
        addDatapointConfig(
            {
                name: 'onSurfaceClick',
            },
            {
                start,
                end,
                isAllDay,
                isClickAndDragEvent,
                selectedCalendarFolderId,
            }
        )
);

/**
 * action invoked when user clicks on surface blank space
 */
export const onSurfaceDoubleClick = action(
    'onSurfaceDoubleClick',
    (
        start: OwaDate,
        end: OwaDate,
        isAllDay: boolean,
        isClickAndDragEvent: boolean,
        selectedCalendarFolderId?: string
    ) =>
        addDatapointConfig(
            {
                name: 'onSurfaceDoubleClick',
            },
            {
                start,
                end,
                isAllDay,
                isClickAndDragEvent,
                selectedCalendarFolderId,
            }
        )
);

export const onSurfaceRightClick = action(
    'onSurfaceRightClick',
    (
        start: OwaDate,
        end: OwaDate,
        isAllDay: boolean,
        event: MouseEvent,
        selectedCalendarFolderId?: string
    ) =>
        addDatapointConfig(
            {
                name: 'onSurfaceRightClick',
            },
            {
                start,
                end,
                isAllDay,
                event,
                selectedCalendarFolderId,
            }
        )
);
